import * as actionTypes from "../types";

const initialState = {
    addedRequest: false,
    requests: [],
    requestEmpty: false,
    requestedBooks: [],
    bookArray: [],
    bookEmpty: false, 
    error: null
}

export default function requestReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.ADD_REQUEST: {
            return {
                ...state,
                addedRequest: action.payload,
            };
        }
        case actionTypes.GET_REQUEST: {
            return {
                ...state,
                requests: action.payload.requests,
                requestEmpty: action.payload.requestEmpty,
                requestedBooks: action.payload.bookID
            };
        }
        case actionTypes.GET_REQUEST_BOOKS: {
            return {
                ...state,
                bookArray: action.payload.borrowedBooks,
                bookEmpty: action.payload.borrowedBooksEmpty
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}


